import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=b517eefa&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=b517eefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b517eefa",
  null
  
)

export default component.exports